import apiClient from '../../../common/functions/api_axios_instance.function';
import { GET_ALL_RING_GROUPS } from '../../../common/constants/constants';

export const getAllRingGroups = async () => {
  try {
    const response = await apiClient.get(GET_ALL_RING_GROUPS);
    return response.data;
  } catch (error) {
    console.error('Error fetching ring groups:', error);
    throw error;
  }
};
